// extracted by mini-css-extract-plugin
export var actionButton = "_7z-1";
export var actionButtons = "_7z-2";
export var actions = "_7z-0";
export var aiUnread = "_7z-10";
export var alignCenter = "_7z-h";
export var backWrapper = "_7z-3";
export var cellContainer = "_7z-4";
export var checkboxContainer = "_7z-5";
export var contentContainer = "_7z-6";
export var contentHeader = "_7z-8";
export var conversationsTableWrapper = "_7z-s";
export var draftReplyBadgeContainer = "_7z-m";
export var dropdownItem = "_7z-b";
export var dropdownItemsContainer = "_7z-a";
export var dropdownTitle = "_7z-c";
export var errorIcon = "_7z-7";
export var filter = "_7z-d";
export var gray = "_7z-i";
export var headerActionButtons = "_7z-e";
export var headerCheckboxContainer = "_7z-f";
export var icon = "_7z-j";
export var menuContainer = "_7z-k";
export var noMoreTicketsIcon = "_7z-12";
export var noMoreTicketsSubText = "_7z-13";
export var oneLine = "_7z-l";
export var optionsButton = "_7z-n";
export var plus = "_7z-o";
export var portalButtonsWrapper = "_7z-g";
export var red = "_7z-p";
export var scrolledTop = "_7z-9";
export var search = "_7z-q";
export var selectedConversationsCount = "_7z-r";
export var spinner = "_7z-t";
export var strong = "_7z-u";
export var summaryCell = "_7z-v";
export var tableContainer = "_7z-11";
export var tagContainer = "_7z-w";
export var threeDots = "_7z-x";
export var twoLines = "_7z-y";
export var unread = "_7z-z";